console.log('dfdf')

$(document).ready(function(){
  
  $(".announcement-bar-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    vertical: true,
    verticalSwiping: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'></button>"
  });   
  
  $('.creview-list').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });

   $(".loved-by-celebs-list").slick({
      arrows:false,
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
       prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'></button>",
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  }); 

  $(".as-seen-on-item").on('click', function() {
    $(this).find(".as-seen-on-modal").addClass('model-open');
  }); 
  $('body').on('click', '.as-seen-on_cls_btn, .as-seen-on-overlay', function() {
    console.log('dfdf');
    $(".as-seen-on-modal").removeClass('model-open');
  })

  var $trigger = $('.product__form__inner');
  var $stickyBtn = $('product-sticky-form');
  var summaryOffset = $trigger.offset().top + $trigger.outerHeight(),
      $selector = $('product-sticky-form, .bacurr-cur-block'),
      $window = $(window),
      $document = $(document);
  var stickyAddToCartToggle = function () {
    var windowScroll = $window.scrollTop(),
        windowHeight = $window.height(),
        documentHeight = $document.height(),
        totalScroll = parseInt(windowScroll + windowHeight) + 60;
    if (summaryOffset < windowScroll && totalScroll !== documentHeight && totalScroll < documentHeight) {
          // console.log('1'); 
          $selector.addClass('sticky_atc_shown');
          console.log($('.template-product .nector-websdk-widget .nector-rewards-widget-container,.template-product .bacurr-cur-blocker .baDropdownStyle.mobile_bottom_right:not(.hideOnMobile)').length); 
         $('.template-product .nector-websdk-widget .nector-rewards-widget-container,.template-product .bacurr-cur-blocker .baDropdownStyle.mobile_bottom_right:not(.hideOnMobile)').attr('style','bottom:90px !important;');
        } else if (totalScroll === documentHeight || totalScroll > documentHeight || summaryOffset > windowScroll) {
          // scroll last footer show windowScroll + windowHeight == documentHeight || summaryOffset > windowScroll 
          // console.log('2'); 
          $selector.removeClass('sticky_atc_shown');
          $('.template-product .nector-websdk-widget .nector-rewards-widget-container,.template-product .bacurr-cur-blocker .baDropdownStyle.mobile_bottom_right:not(.hideOnMobile)').removeAttr('style');
        }
  }
  if($(window).width() < 768){
   stickyAddToCartToggle();
   $window.scroll(stickyAddToCartToggle); 
  }

})



